import { Host, h } from '@stencil/core';
import { createPopper } from '@popperjs/core';
const FALLBACK_PLACEMENTS = {
  top: 'bottom',
  bottom: 'top',
};
export class PesTooltip {
  async activeDidChange() {
    var _a;
    await ((_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.setOptions(this.getOptions()));
    this.updateWhenActive();
  }
  async referenceDidChange() {
    var _a;
    (_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.destroy();
    this.popperInstance = createPopper(this.reference, this.host, this.getOptions());
    this.updateWhenActive();
  }
  triggerUpdate() {
    var _a;
    return (_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.forceUpdate();
  }
  constructor() {
    this.createArrowRef = (el) => {
      this.arrowRef = el;
    };
    this.reference = undefined;
    this.arrow = false;
    this.placement = 'top';
    this.active = false;
    this.option = 'indent';
    this.host.dir = document.documentElement.dir || 'auto';
  }
  componentDidLoad() {
    if (this.reference) {
      this.popperInstance = createPopper(this.reference, this.host, this.getOptions());
    }
    this.updateWhenActive();
  }
  componentWillUnload() {
    var _a;
    (_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.destroy();
  }
  updateWhenActive() {
    var _a;
    if (this.active) {
      (_a = this.popperInstance) === null || _a === void 0 ? void 0 : _a.forceUpdate();
    }
  }
  getOptions() {
    const modifiers = [
      {
        name: 'flip',
        enabled: true,
        options: {
          fallbackPlacements: [FALLBACK_PLACEMENTS[this.placement]],
        },
      },
      {
        name: 'offset',
        enabled: true,
        options: {
          offset: [0, 12],
        },
      },
      {
        name: 'eventListeners',
        enabled: this.active,
      },
    ];
    if (this.arrow) {
      modifiers.push({
        name: 'arrow',
        options: {
          element: this.arrowRef,
        },
      });
    }
    return {
      strategy: 'fixed',
      placement: this.placement,
      modifiers,
    };
  }
  render() {
    return (h(Host, null, this.arrow && h("div", { ref: this.createArrowRef, class: "tooltip__arrow" }), h("div", { class: {
        tooltip__content: true,
        [`tooltip__content--option-${this.option}`]: true,
      } }, h("slot", null))));
  }
  static get is() { return "pes-tooltip"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["tooltip.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["tooltip.css"]
    };
  }
  static get properties() {
    return {
      "reference": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "HTMLElement",
          "resolved": "HTMLElement",
          "references": {
            "HTMLElement": {
              "location": "global"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "reference element, which tooltip placement calculations are based on"
        }
      },
      "arrow": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "show tooltip arrow, that points toward the reference element"
        },
        "attribute": "arrow",
        "reflect": false,
        "defaultValue": "false"
      },
      "placement": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'top' | 'bottom'",
          "resolved": "\"bottom\" | \"top\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "preferred placement of the tooltip."
        },
        "attribute": "placement",
        "reflect": false,
        "defaultValue": "'top'"
      },
      "active": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "show tooltip"
        },
        "attribute": "active",
        "reflect": true,
        "defaultValue": "false"
      },
      "option": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'fill' | 'indent'",
          "resolved": "\"fill\" | \"indent\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines the paddings of the tooltip content.\nWhen set to `fill`, the tooltip has top and bottom paddings.\nWhen set to `indent`, the tooltip is indented around.\nBy default is `indent`."
        },
        "attribute": "option",
        "reflect": false,
        "defaultValue": "'indent'"
      }
    };
  }
  static get methods() {
    return {
      "triggerUpdate": {
        "complexType": {
          "signature": "() => Promise<void>",
          "parameters": [],
          "references": {},
          "return": "Promise<void>"
        },
        "docs": {
          "text": "",
          "tags": []
        }
      }
    };
  }
  static get elementRef() { return "host"; }
  static get watchers() {
    return [{
        "propName": "active",
        "methodName": "activeDidChange"
      }, {
        "propName": "reference",
        "methodName": "referenceDidChange"
      }];
  }
}
